"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _ = require("./");
var _helpers = require("../../../helpers");
var _uuid = _interopRequireDefault(require("uuid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SignUpForm extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {});
    _defineProperty(this, "handleOptinChange", (id, body) => {
      const {
        state,
        onChange
      } = this.props;
      const UserOptInEntries = state.UserOptInEntries.map(optin => {
        if (optin.OptInEntryId === id) return {
          ...optin,
          ...body
        };
        return optin;
      });
      onChange({
        UserOptInEntries
      });
    });
    _defineProperty(this, "checkFieldsMatch", () => {
      document.getElementById('PasswordConfirm').setCustomValidity(document.getElementById('PasswordConfirm').value !== document.getElementById('Password').value ? "Passwords do not match." : "");
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.invitation.fetched !== nextProps.invitation.fetched && nextProps.invitation.data) {
      nextProps.onChange({
        Invitation: nextProps.invitation.data
      });
      Object.entries(nextProps.invitation.data).map(([key, value]) => {
        if (key in nextProps.state) nextProps.onChange({
          [key]: value
        });
      });
    }
    if (this.props.optins.fetched !== nextProps.optins.fetched && nextProps.optins.fetched) nextProps.onChange({
      UserOptInEntries: nextProps.optins.data.map(optin => {
        return {
          OptInEntryId: optin.Id,
          UserAccepted: false
        };
      })
    });
  }
  render() {
    const {
      auth,
      invitation,
      optins,
      onSubmit,
      onChange,
      state,
      messages,
      fetching
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: onSubmit,
      className: 'position-relative',
      onInput: this.checkFieldsMatch
    }, messages && messages.map(message => /*#__PURE__*/_react.default.createElement("div", {
      className: `alert ${(0, _helpers.getAlertClassName)(message.type)}`,
      role: "alert",
      key: _uuid.default.v4()
    }, message.text)), fetching && /*#__PURE__*/_react.default.createElement(_components.Spinner, null), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: 'GivenName',
      className: 'text-muted text-uppercase'
    }, /*#__PURE__*/_react.default.createElement("small", null, "First name")), /*#__PURE__*/_react.default.createElement("input", {
      type: 'text',
      name: 'GivenName',
      className: 'form-control',
      id: 'GivenName',
      value: state.GivenName,
      onChange: event => onChange({
        GivenName: event.target.value
      })
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: 'FamilyName',
      className: 'text-muted text-uppercase'
    }, /*#__PURE__*/_react.default.createElement("small", null, "Last name")), /*#__PURE__*/_react.default.createElement("input", {
      type: 'text',
      name: 'FamilyName',
      className: 'form-control',
      id: 'FamilyName',
      value: state.FamilyName,
      onChange: event => onChange({
        FamilyName: event.target.value
      })
    })))), invitation.data.CanAlterEmail ? /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: 'Email',
      className: 'text-muted text-uppercase'
    }, /*#__PURE__*/_react.default.createElement("small", null, "Email")), /*#__PURE__*/_react.default.createElement("input", {
      id: 'Email',
      type: 'email',
      value: state.Email,
      className: 'form-control',
      name: 'Email',
      onChange: event => onChange({
        Email: event.target.value
      }),
      required: true
    })))) : /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: 'Email',
      className: 'text-muted text-uppercase'
    }, /*#__PURE__*/_react.default.createElement("small", null, "Email")), /*#__PURE__*/_react.default.createElement("input", {
      id: 'Email',
      type: 'email',
      value: state.Email,
      className: 'form-control',
      name: 'Email',
      disabled: true
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: 'Password',
      className: 'text-muted text-uppercase'
    }, /*#__PURE__*/_react.default.createElement("small", null, "Password")), /*#__PURE__*/_react.default.createElement(_.PasswordStrength, {
      onInputChange: event => onChange({
        Password: event.target.value
      }),
      onPasswordValidate: valid => this.setState({
        passwordValid: valid
      }),
      rules: auth.passwordRules
    }, /*#__PURE__*/_react.default.createElement(_.PasswordInput, {
      type: 'password',
      id: 'Password',
      name: 'Password',
      value: state.Password,
      onChange: this.onInputChange,
      required: true
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: 'PasswordConfirm',
      className: 'text-muted text-uppercase'
    }, /*#__PURE__*/_react.default.createElement("small", null, "Confirm Password")), /*#__PURE__*/_react.default.createElement(_.PasswordInput, {
      type: 'password',
      id: 'PasswordConfirm',
      name: 'PasswordConfirm',
      value: this.state.passwordConfirm,
      onChange: event => this.setState({
        passwordConfirm: event.target.value
      }),
      required: true
    })))), optins.fetched && optins.data.map(optin => {
      const checked = state.UserOptInEntries ? state.UserOptInEntries.find(userOptinentry => userOptinentry.OptInEntryId === optin.Id).UserAccepted : false;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'row d-flex',
        key: optin.Id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-control custom-checkbox mt-2"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: 'checkbox',
        className: 'custom-control-input',
        id: optin.Id,
        onChange: event => this.handleOptinChange(optin.Id, {
          UserAccepted: event.target.checked
        }),
        required: !optin.Optional,
        checked: checked
      }), optin.Optional ? /*#__PURE__*/_react.default.createElement("label", {
        className: "custom-control-label",
        htmlFor: optin.Id
      }, "I accept the ", /*#__PURE__*/_react.default.createElement("a", {
        href: '#',
        onClick: () => this.setState({
          [`modal${optin.Id}`]: true
        })
      }, (0, _helpers.isValidJson)(optin.Title) ? JSON.parse(optin.Title).English : optin.Title, " "), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontStyle: "italic",
          opacity: "0.5",
          fontSize: "smaller"
        }
      }, "(optional)")) : /*#__PURE__*/_react.default.createElement("label", {
        className: "custom-control-label",
        htmlFor: optin.Id
      }, "I accept the ", /*#__PURE__*/_react.default.createElement("a", {
        href: '#',
        onClick: () => this.setState({
          [`modal${optin.Id}`]: true
        })
      }, (0, _helpers.isValidJson)(optin.Title) ? JSON.parse(optin.Title).English : optin.Title))), /*#__PURE__*/_react.default.createElement(_components.ModalDialog, {
        isOpen: this.state[`modal${optin.Id}`],
        headerText: (0, _helpers.isValidJson)(optin.Title) ? JSON.parse(optin.Title).English : optin.Title,
        bodyText: /*#__PURE__*/_react.default.createElement(_components.RichText, {
          value: optin.Text
        }),
        buttonPrimOnClick: () => this.setState(state => {
          return {
            [`modal${optin.Id}`]: !state[`modal${optin.Id}`]
          };
        }),
        buttonPrimText: "Close"
      })));
    }), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "btn btn-primary mt-5"
    }, "Sign up"));
  }
}
var _default = exports.default = SignUpForm;
module.exports = exports.default;